"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BugsnagApiKeys = void 0;
var BugsnagApiKeys;
(function (BugsnagApiKeys) {
    BugsnagApiKeys["LIVE_API_KEY"] = "91579e9e5b7033824268ec8e34347028";
    BugsnagApiKeys["DEV_API_KEY"] = "a92333262f4737cf88daca999eae2ffb";
})(BugsnagApiKeys = exports.BugsnagApiKeys || (exports.BugsnagApiKeys = {}));
//# sourceMappingURL=bugsnagApiKeys.enum.js.map